export default __webpack_public_path__ + "static/media/slide2.3ae28cf7.png";